import React from 'react';
import PropTypes from 'prop-types';
import translate from '../translate';

function StatusProgressItem(props) {
  const { t, line, text, isActive, hasLineRight } = props;
  return (
    <div
      className={`circle-wrapper ${isActive ? 'circle-wrapper-active' : ''}`}
    >
      <div className="circle-container">
        <div className="circle" />
        <span className="text">
          <span className="text">{text ? t(text) : ''}</span>
        </span>
      </div>
      {line ? <div className="line" /> : null}
      {hasLineRight ? <div className="line line-right" /> : null}
    </div>
  );
}

StatusProgressItem.propTypes = {
  t: PropTypes.func.isRequired,
  line: PropTypes.bool,
  text: PropTypes.string,
  isActive: PropTypes.bool.isRequired,
  hasLineRight: PropTypes.bool,
};

StatusProgressItem.defaultProps = {
  line: false,
  hasLineRight: false,
  text: '',
};

export default translate(StatusProgressItem);
